let request = require('../request.js')
// 当前是否是https页面访问
let isHttps = window.location.protocol.indexOf('https') != -1
// let postWay = isHttps ? 'appletPost' : 'noCommonPost'
// let postWay4s = isHttps ? 'appletPost4s' : 'noCommonPost4s'
let postWay = 'noCommonPost'
let postWay4s = 'noCommonPost4s'

// 访客（门禁）预约相关API
let RKEApi = {
	// 获取地址
	getAddress: function (data) {
		return request[postWay]('/common/Visitor/getAddress', data)
	},
	// 查询被访者信息是否正确
	getVisitor: function (data) {
		return request[postWay]('/common/Visitor/getVisitor', data)
	},
	// 提交预约信息
	visitorInfo: function (data) {
		return request[postWay]('/common/Visitor/visitorInfo', data)
	},
	// 获取访客信息
	getAppointmentnInfo: function (data) {
		return request[postWay]('/common/Visitor/getAppointmentnInfo', data)
	},
	// 授权提交
	updateAppintmentStatus: function (data) {
		return request[postWay]('/common/Visitor/updateAppintmentStatus', data)
	},
	// 上传图片
	uploadImage: function (data) {
		return request[postWay]('/MiniProgram/IcPublic/uploadImage', data, 'file')
	},
}

// 小程序相关api
let AppletApi = {
	// 一次性打开箱子
	shareOpen: function (data) {
		return request.noCommonPost('/MiniProgram/IcPublic/shareOpen', data);
	},
	// 获取设备中心设备详情--分享页
	getDeviceDetailsShare: function (data) {
		return request.noCommonPost('/MiniProgram/IcPublic/getDeviceDetails', data);
	},
	// 获取待办事项列表详情--待办事项
	getAppointInfo: function (data) {
		return request.noCommonPost('/MiniProgram/IcPublic/getAppointInfo', data);
	},
	// 修改设备预约得状态
	updateDeviceAppointStatus: function (data) {
		return request.noCommonPost('/MiniProgram/IcPublic/updateDeviceAppointStatus', data);
	},
}

// 生产工具小程序相关api
let ToolAppletApi = {
	// 设备注册激活
	RegisterDevice: function (data) {
		return request[postWay4s]('/service/RegisterDevice', data);
	},
	// 获取设备信息
	GetDeviceInfo: function (data) {
		return request[postWay4s]('/service/device/GetDeviceInfo', data);
	},
	// 获取省市区分组
	GetAreaStree: function () {
		return request[postWay4s]('/service/area/GetAreaStree.json');
	},
	// 获取空间分组（树状）
	GetSpaceByCompanyId: function (data) {
		return request[postWay4s]('/service/Space/GetSpaceByCompanyId.json', data);
	},

	
}

export {
	RKEApi,
	AppletApi,
	ToolAppletApi
}


//////////////////
// WEBPACK FOOTER
// ./static/js/phone/phoneApi.js
// module id = null
// module chunks = 